export default class CreateModelVersionModel {
    assetId = null;
    name = null;
    associatedScanId = null;
    supplementaryScans = [];
    primaryScanTrimRadius = 0;
    setToCurrent = false;
    description = null;
    createdBy = null;

    // Default camera viewpoint the runtime viewer opens at. All zero = "frame the primary scan"
    // (the historical default). Set non-zero by the duplicate dialog so the source version's
    // saved view carries across to the new version.
    modelViewPointX = 0;
    modelViewPointY = 0;
    modelViewPointZ = 0;
    modelViewPointRotationX = 0;
    modelViewPointRotationY = 0;
    modelViewPointRotationZ = 0;

    /**
     * @param {string} assetId
     * @param {string} name
     * @param {string} description
     * @param {string} associatedScanId - the primary (base) scan for this version.
     * @param {ScanAssociation[]} supplementaryScans - extra scans layered onto the primary, each with its transform and trim radius.
     * @param {boolean} setToCurrent
     * @param {string} createdBy
     * @param {number} [primaryScanTrimRadius=0] - camera-helper trim radius for the primary scan (0 = no trim). Carries over when a duplicate promotes a supplementary into the primary slot.
     * @param {object} [viewpoint] - {x, y, z, rotationX, rotationY, rotationZ} default camera viewpoint. Omit to use the "frame the scan" default.
     */
    constructor(assetId, name, description, associatedScanId, supplementaryScans, setToCurrent, createdBy, primaryScanTrimRadius = 0, viewpoint = null){
        this.assetId = assetId;
        this.name = name;
        this.description = description;
        this.associatedScanId = associatedScanId;
        this.supplementaryScans = supplementaryScans ?? [];
        this.createdBy = createdBy;
        this.setToCurrent = setToCurrent;
        this.primaryScanTrimRadius = primaryScanTrimRadius;

        if (viewpoint) {
            this.modelViewPointX = Number(viewpoint.x) || 0;
            this.modelViewPointY = Number(viewpoint.y) || 0;
            this.modelViewPointZ = Number(viewpoint.z) || 0;
            this.modelViewPointRotationX = Number(viewpoint.rotationX) || 0;
            this.modelViewPointRotationY = Number(viewpoint.rotationY) || 0;
            this.modelViewPointRotationZ = Number(viewpoint.rotationZ) || 0;
        }
    }
}
